<template>
  <div class="tabs d-flex w-100">
    <div
      v-for="(tab, index) in tableTabs"
      :key="index"
      class="flex-grow-1 flex-sm-grow-0"
    >
      <div
        :data-test-id="tab.value"
        class="table-tab"
        :class="{ active: tab.value === activeTab }"
        @click="setActiveTableTab(tab)"
      >
        {{ tab.label }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "StudentAptPassTabs",
  data: () => ({
    tableTabs: [
      { label: "Next 7 Days", value: "nextSevenDays" },
      { label: "Beyond 7 Days", value: "prevSevenDays" }
    ]
  }),
  computed: {
    ...mapGetters({
      activeTab: "studentAptPass/activeTab"
    })
  },
  methods: {
    setActiveTableTab(tab) {
      this.$store.commit("studentAptPass/SET_ACTIVE_TAB", tab.value)
    }
  }
}
</script>

<style></style>
